/**
 * @generated SignedSource<<1bb58cecff91381642fa14cf69d3ad8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useEliteSeatProgressUpdatedSubscription$variables = {};
export type useEliteSeatProgressUpdatedSubscription$data = {
  readonly eliteSeatProgressUpdated: {
    readonly currentLevel: {
      readonly name: string;
      readonly tierStartUsd: number;
      readonly tierStartLevel: number;
      readonly tierStep: number;
      readonly tierCount: number;
      readonly bonusUsd: ReadonlyArray<number>;
    } | null;
    readonly nextLevel: {
      readonly name: string;
      readonly tierStartUsd: number;
      readonly tierStartLevel: number;
      readonly tierStep: number;
      readonly tierCount: number;
      readonly bonusUsd: ReadonlyArray<number>;
    } | null;
    readonly currentTier: number;
    readonly tierProgress: number;
    readonly levelProgress: number;
    readonly pendingPayouts: ReadonlyArray<{
      readonly levelNr: number;
      readonly bonusUsd: number;
      readonly dateTime: string;
    }>;
    readonly wagerAmountUsd: number;
  };
};
export type useEliteSeatProgressUpdatedSubscription = {
  variables: useEliteSeatProgressUpdatedSubscription$variables;
  response: useEliteSeatProgressUpdatedSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bonusUsd",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tierStartUsd",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tierStartLevel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tierStep",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "tierCount",
    "storageKey": null
  },
  (v0/*: any*/)
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EliteSeatProgress",
    "kind": "LinkedField",
    "name": "eliteSeatProgressUpdated",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EliteSeatLevel",
        "kind": "LinkedField",
        "name": "currentLevel",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EliteSeatLevel",
        "kind": "LinkedField",
        "name": "nextLevel",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentTier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tierProgress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "levelProgress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PendingElitePayout",
        "kind": "LinkedField",
        "name": "pendingPayouts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "levelNr",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateTime",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wagerAmountUsd",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useEliteSeatProgressUpdatedSubscription",
    "selections": (v2/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useEliteSeatProgressUpdatedSubscription",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a4eedae8b89b6ef9d89dbe7605ce1855",
    "id": null,
    "metadata": {},
    "name": "useEliteSeatProgressUpdatedSubscription",
    "operationKind": "subscription",
    "text": "subscription useEliteSeatProgressUpdatedSubscription {\n  eliteSeatProgressUpdated {\n    currentLevel {\n      name\n      tierStartUsd\n      tierStartLevel\n      tierStep\n      tierCount\n      bonusUsd\n    }\n    nextLevel {\n      name\n      tierStartUsd\n      tierStartLevel\n      tierStep\n      tierCount\n      bonusUsd\n    }\n    currentTier\n    tierProgress\n    levelProgress\n    pendingPayouts {\n      levelNr\n      bonusUsd\n      dateTime\n    }\n    wagerAmountUsd\n  }\n}\n"
  }
};
})();

(node as any).hash = "266c57905bc1931f8f1a707b628bdaf3";

export default node;
